const countriesByLocalesKls = [
  {
    name: 'Keyrus Life Science - EN',
    technicalName: 'Keyrus Life Science - EN',
    locale: 'U.S. English (en-US)',
    localeCode: 'en-US',
    localeName: 'English',
    urlPrefix: 'en',
    countryCode: 'en',
    continent: 'Global',
    salesforceCountry: 'r',
    campaignToken: 'r',
  },
  {
    name: 'Keyrus Life Science - FR',
    technicalName: 'Keyrus Life Science - FR',
    locale: 'French (France) (fr-FR)',
    localeCode: 'fr-FR',
    localeName: 'French',
    urlPrefix: 'fr',
    countryCode: 'fr',
    continent: 'Global',
    salesforceCountry: 'r',
    campaignToken: 'r',
  },
]

module.exports = {
  countriesByLocalesKls,
}
